module.exports = __webpack_public_path__ + "img/logoW.767007f5.png";